<mat-form-field class="bold-required-field">
  <mat-label>
    {{ fieldLabel }}
  </mat-label>
  <input
    matInput
    [formControl]="fieldControl"
    [attr.test-id]="testId"
    (input)="searchFn($event)"
    [matAutocomplete]="deliveryAddressAuto"
    [readonly]="disableField"
  />
  <mat-autocomplete
    requireSelection
    (optionSelected)="onOptionSelected($event)"
    #deliveryAddressAuto="matAutocomplete"
    [displayWith]="displayValueFn"
  >
    <mat-option *ngFor="let carrier of carriers" [value]="carrier">
      {{ carrier.name }}
      <span *ngIf="carrier.extId" class="carrier-info">
        {{ carrier.extId }}
      </span>
      <span *ngIf="carrier.number" class="carrier-info"> ({{ carrier.number }}) </span>
    </mat-option>
    <div *ngIf="isLoadMoreEnabled" class="load-more">
      <span class="link" (click)="onLoadMore()">
        <ui-svg-icon [name]="iconNames.Refresh" class="tw-align-middle"></ui-svg-icon>
        {{ 'monitoring.uli.create.uliInfo.loadMoreAddress' | translate : { amount: loadMoreAmount } }}
      </span>
    </div>
  </mat-autocomplete>
  <mat-error *ngIf="fieldControl.invalid && (fieldControl.dirty || fieldControl.touched)">
    <ui-field-error-messages [control]="fieldControl"></ui-field-error-messages>
  </mat-error>
</mat-form-field>
